import script from "./EventWaiver.vue?vue&type=script&setup=true&lang=js"
export * from "./EventWaiver.vue?vue&type=script&setup=true&lang=js"

import "./EventWaiver.vue?vue&type=style&index=0&id=6b83a2ec&scoped=true&lang=css"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b83a2ec"]])

export default __exports__